import axios, { AxiosError } from "axios";
import config from "../../../../../../config";
import { ImageData } from "../../../../../gest/CustomGallery/CustomGallery";
import { IIntervention } from "./_models/Intervention";
import { IList } from "./_models/List";
import { IPlan } from "./_models/Plan";
import { PhotoResponse } from "./InterventionManagement/InterventionManagement";
import { WFMControllerName } from "./static";

export const renderInteventionTypeColor = (v: IIntervention) => {
    switch (v.type) {
        case "installation": return "text-success";
        case "removal": return "text-danger";
        case "replacement":
        case "repair": return "text-warning";
        default: return "text-info";
    }
};

export const renderInteventionStatusColor = (v: IIntervention) => {
    switch (v.status) {
        case "processed": return "text-success";
        case "attempted_processing": return "text-danger";
        case "suspended": return "text-warning";
        default: return "text-info";
    }
};

export const cleanEmptyNullString = (str?: string) => str ? str.toLowerCase() === "null" : undefined;

export const filterLogPhotos = (lang: any, log_id: number, photos?: PhotoResponse): ImageData[][] => {
    if (!photos) return [];

    const tmp = Object
        .keys(photos)
        .map(category => photos[category]
            .filter(image => log_id < 0 || (image.log_id === log_id))
            .map(image => ({
                id: image.id,
                title: lang[category] ?? category,
                src: image.url,
                category
            }))
        );

    if (tmp.every(v => v.length === 0)) return [];

    return tmp.filter(v => v.length > 0);   //removes empty collections
};

export const editPlanNameAPI = async (plan: IPlan, newName: string) => {
    if (plan.name?.toLowerCase() !== newName?.toLowerCase()) {
        return await axios.patch(`${config.api.internal}/${WFMControllerName}/Plan/${plan.id}/Name/${newName}`, undefined, { withCredentials: true })
            .then(res => res.status === 200)
            .catch((err: AxiosError) => console.error(err));
    }
};

export const setFreePlanName = (planName: string) => `Free ${planName.replace(/\bfree\b/gi, "").trim()}`;

export const composeName = (list?: IList | IPlan) => list ? `${new Date(("created_at" in list ? list.created_at : list.start_date)!).toLocaleDateString()} - ${list.name}` : undefined;